import type { Id } from '@e-socna/data-layer';

import type { IdOption } from '../../../components/IdAutocomplete/types';

const SUGGESTED_TEMPLATES_GROUP_LABEL =
  'Modèles suggérés pour ce type de mission';
const OTHER_TEMPLATES_GROUP_LABEL = 'Autres modèles disponibles';

export interface DocumentTemplateOptionSource {
  readonly _id: Id;
  readonly label: string;
}

export const buildDocumentTemplateOptions = (
  templates: readonly DocumentTemplateOptionSource[],
  suggestedTemplateIds: ReadonlySet<Id>,
): readonly IdOption<Id>[] => {
  const suggested = templates.filter((template) =>
    suggestedTemplateIds.has(template._id),
  );
  const others = templates.filter(
    (template) => !suggestedTemplateIds.has(template._id),
  );

  return [
    ...suggested.map((template) => ({
      id: template._id,
      label: template.label,
      group: SUGGESTED_TEMPLATES_GROUP_LABEL,
    })),
    ...others.map((template) => ({
      id: template._id,
      label: template.label,
      group: OTHER_TEMPLATES_GROUP_LABEL,
    })),
  ];
};
